__turbopack_context__.v({
  "Chip": "KBVUuG_Chip",
  "Detail": "KBVUuG_Detail",
  "DetailName": "KBVUuG_DetailName",
  "DetailValue": "KBVUuG_DetailValue",
  "Empty": "KBVUuG_Empty",
  "List": "KBVUuG_List",
  "Log": "KBVUuG_Log",
  "Row": "KBVUuG_Row",
  "Row--Expandable": "KBVUuG_Row--Expandable",
  "RowAside": "KBVUuG_RowAside",
  "RowBody": "KBVUuG_RowBody",
  "RowButton": "KBVUuG_RowButton",
  "RowDate": "KBVUuG_RowDate",
  "RowDetails": "KBVUuG_RowDetails",
  "RowIcon": "KBVUuG_RowIcon",
  "RowInfo": "KBVUuG_RowInfo",
  "RowMain": "KBVUuG_RowMain",
  "RowTitle": "KBVUuG_RowTitle",
  "ShowMore": "KBVUuG_ShowMore",
  "Source": "KBVUuG_Source",
  "SourceList": "KBVUuG_SourceList",
  "Title": "KBVUuG_Title",
  "TitleYears": "KBVUuG_TitleYears",
  "material-symbols-outlined": "KBVUuG_material-symbols-outlined",
  "material-symbols-rounded": "KBVUuG_material-symbols-rounded",
  "material-symbols-sharp": "KBVUuG_material-symbols-sharp",
  "skeleton-loading": "KBVUuG_skeleton-loading",
});
